@import "../../../globalStyles/commons";

